import { triplaServer } from 'src/apis/server'

export default {
  getTemporaryStorage(key) {
    return triplaServer.get(`api/v1/temporary_storages/${key}`).then((res) => res.data)
  }
}
